import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class RequestedDoc  {
    _originalTypeClassName = "zERP.BO.RequestedDoc";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
RequestedDoc.translate = translateService;
}
this.Id = null;
this.NextPartitionKey = null;
this.NextRowKey = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
NextPartitionKey:any;
NextRowKey:any;
ContinuationToken:any;
InvoicesDoc:any;
CancelledInvoicesDoc:any;
IncomeClassificationsDoc:any;
ExpensesClassificationDoc:any;
static setContinuationToken = ($this, value) => {
var oldValue = $this.ContinuationToken;
$this.ContinuationToken = value;
if (value != null) {
}
}
static setInvoicesDoc = ($this, value) => {
var oldValue = $this.InvoicesDoc;
$this.InvoicesDoc = value;
if (value != null) {
}
}
static setCancelledInvoicesDoc = ($this, value) => {
var oldValue = $this.CancelledInvoicesDoc;
$this.CancelledInvoicesDoc = value;
if (value != null) {
}
}
static setIncomeClassificationsDoc = ($this, value) => {
var oldValue = $this.IncomeClassificationsDoc;
$this.IncomeClassificationsDoc = value;
if (value != null) {
}
}
static setExpensesClassificationDoc = ($this, value) => {
var oldValue = $this.ExpensesClassificationDoc;
$this.ExpensesClassificationDoc = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}